import React from 'react'
import styled from 'styled-components'

import { Button } from 'components'

const Container = styled.div`
    display: flex;
    margin-top: 0.5rem;
`

const SignOutInput = props => {
    const {
        onSignOut,
        onCancel
    } = props;

    const cancelStyle = {
        backgroundColor: 'var(--primary-color)',
        border: '1px solid var(--secondary-color)',
        margin: '0 0.5rem 0 0',
        boxShadowColor: 'transparent'
    }

    const signOutStyle = {
        backgroundColor: 'var(--focus-color)',
        margin: 0
    }

    return (
        <Container>
            <Button text='Cancel' onSelect={onCancel} styles={cancelStyle}/>
            <Button text='Confirm' onSelect={onSignOut} styles={signOutStyle}/>
        </Container>
    )
}

export default SignOutInput